export const ACCOUNTS_WITH_BUDGET_CATEGORIES = ['Expenses/Recruiting/USD'];
